const mediaItems = [
  {
    id: 1,
    title: '《剑与魔法》动画化PV首发',
    desc: '人气韩漫《剑与魔法》正式宣布动画化，首曝PV展示华丽战斗场面。',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20anime%20style%20promotional%20visual%20with%20a%20fantasy%20warrior%20in%20dynamic%20action%20pose%2C%20golden%20and%20crimson%20color%20palette%2C%20dramatic%20lighting%20effects%2C%20video%20thumbnail%20style%20with%20play%20button%20overlay%20area%2C%20clean%20cream%20background&width=800&height=500&seq=media-01&orientation=landscape',
    duration: '03:25',
    views: '56万',
  },
  {
    id: 2,
    title: 'YY漫画阅读模式深度体验',
    desc: '全面展示下拉式、弹窗、翻页三种阅读模式的实际使用效果和切换方法。',
    image: 'https://readdy.ai/api/search-image?query=A%20digital%20comic%20reader%20app%20interface%20showcase%20with%20multiple%20reading%20modes%20displayed%2C%20modern%20clean%20UI%20design%2C%20warm%20amber%20and%20coral%20accents%2C%20product%20demo%20style%20thumbnail%2C%20clean%20cream%20background&width=800&height=500&seq=media-02&orientation=landscape',
    duration: '05:12',
    views: '32万',
  },
  {
    id: 3,
    title: '韩漫推荐：编辑部精选10部必读',
    desc: 'YY漫画编辑团队为你精选10部不可错过的韩国漫画作品。',
    image: 'https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20Korean%20manhwa%20cover%20art%20arranged%20in%20a%20grid%2C%20warm%20vibrant%20tones%2C%20editorial%20presentation%20style%2C%20top%2010%20badge%20aesthetic%2C%20clean%20cream%20background&width=800&height=500&seq=media-03&orientation=landscape',
    duration: '08:40',
    views: '89万',
  },
  {
    id: 4,
    title: '漫画家的一天：创作幕后揭秘',
    desc: '走进漫画创作者的工作室，记录从草图到成稿的完整创作流程。',
    image: 'https://readdy.ai/api/search-image?query=An%20artist%20workspace%20with%20drawing%20tablet%20and%20manga%20sketches%2C%20warm%20natural%20light%20from%20window%2C%20creative%20studio%20atmosphere%2C%20behind%20the%20scenes%20documentary%20style%2C%20muted%20earthy%20tones%2C%20clean%20cream%20background&width=800&height=500&seq=media-04&orientation=landscape',
    duration: '12:18',
    views: '41万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-22 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            精彩视频
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            热门漫画动画化资讯与深度内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all group cursor-pointer"
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: '16/10' }}>
                <img
                  src={item.image}
                  alt={`YY漫画视频 - ${item.title}`}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-xl text-primary-600 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-background-50 text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                  <span><i className="ri-eye-line mr-1"></i>{item.views}次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}